export default "__VITE_ASSET__8c92652a__"